import styled from '@emotion/styled';

import { BannerTableContainer, HeaderContainer, Header } from '@/pages/PromotionalBanners/PromotionalBanners.style';

export const Container = styled(BannerTableContainer)`
    padding: 0 24px;
`;

export { HeaderContainer, Header };

export const AlertContainer = styled.div`
    padding: 25px;
    margin: 25px;
    border: 1px solid ${({ theme }) => theme.color.io.warning500};
    border-radius: 8px;
    background-color: ${({ theme }) => theme.color.io.warning100};

    button {
        margin-top: ${({ theme }) => theme.spacing[4]};
    }
`;

export const AlertTitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const TableContainer = styled.div`
    margin: ${({ theme }) => theme.savory.spacing[3]};
`;
